import { createSlice } from '@reduxjs/toolkit';

export const loggingSlices = createSlice({
	name: 'distributorPortal_logging',
	initialState: {},
	reducers: {
		// Get Activity Log
		getActivityLog_request: (state) => {
			state.getActivityLog_requesting = true;
			state.getActivityLog_isSuccessful = undefined;
		},
		getActivityLog_success: (state, action) => {
			state.getActivityLog_requesting = false;
			state.getActivityLog_isSuccessful = true;

			state.activityLog = action?.payload?.data;
			state.activityLogHeaders = action?.payload?.headers;
		},
		getActivityLog_failure: (state) => {
			state.getActivityLog_requesting = false;
			state.getActivityLog_isSuccessful = false;
		},

		// Get Module Name
		getModuleNames_request: (state) => {
			state.getModuleNames_requesting = true;
			state.getModuleNames_isSuccessful = undefined;
		},
		getModuleNames_success: (state, action) => {
			state.getModuleNames_requesting = false;
			state.getModuleNames_isSuccessful = true;

			state.moduleNameList = action.payload?.data;
		},
		getModuleNames_failure: (state) => {
			state.getModuleNames_requesting = false;
			state.getModuleNames_isSuccessful = false;
		},
	},
});

export const { 
	getActivityLog_request, getActivityLog_success, getActivityLog_failure,
	getModuleNames_request, getModuleNames_success, getModuleNames_failure,
} = loggingSlices.actions;

export default loggingSlices.reducer;